export function formatCssUnit(value) {
  const isPureNumber = /^-?\d+(\.\d+)?$/.test(String(value));

  return isPureNumber ? `${value}px` : value;
}
